export interface InlineOverflowState {
    overflowing: boolean;
}

const INLINE_OVERFLOW_THRESHOLD = 1;

export const getInlineOverflowState = (
    element: Pick<HTMLElement, 'clientWidth' | 'scrollWidth'>,
): InlineOverflowState => ({
    overflowing: element.scrollWidth - element.clientWidth > INLINE_OVERFLOW_THRESHOLD,
});
